import { isPreview } from './environment';

export const beforeSend = event => {
  if (event?.tags?.statusCode === 404 && isPreview) {
    return null;
  }
  return event;
};
